<div class="page-size-switcher" [ngClass]="{'disabled': disabled}">
  <span>{{'app.devicesPage.itemsPerPage' | translate}}</span>
      <mat-select [ngModel]="selectedSize"
                  (ngModelChange)="changeSize($event)"
                  [disabled]="disabled"
      >
        <mat-option *ngFor="let option of options"
                    [value]="option"
        >{{option}}</mat-option>
      </mat-select>
</div>
